import {CONTACT_FORM_SENDING, CONTACT_FORM_SENT, CONTACT_FORM_ERROR} from './types';

const initialState = {
    emailSent: false,
    emailSending: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case CONTACT_FORM_SENT:
            return {
                ...state,
                emailSent: action.payload,
                emailSending: false
            };
        case CONTACT_FORM_SENDING:
            return {
                ...state,
                emailSending: true
            };
        case CONTACT_FORM_ERROR:
            return {
                ...state,
                emailSending: false
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/features/Contact/reducers.js